import { Chip, Box, Typography, Tooltip } from '@mui/material';
import {
  TrendingUp,
  TrendingDown,
  ShowChart,
  SignalCellularAlt,
} from '@mui/icons-material';
import { OCILevel, OCIBadgeProps } from '../../types/oci.types';

const OCI_CONFIG: Record<OCILevel, { 
  label: string; 
  color: 'success' | 'info' | 'warning' | 'error';
  icon: React.ReactElement;
  description: string;
}> = {
  VERY_HIGH: {
    label: 'Very High',
    color: 'error',
    icon: <TrendingUp />,
    description: 'Extremely competitive - requires significant investment',
  },
  HIGH: {
    label: 'High',
    color: 'warning',
    icon: <SignalCellularAlt />,
    description: 'Highly competitive - substantial effort needed',
  },
  MEDIUM: {
    label: 'Medium',
    color: 'info',
    icon: <ShowChart />,
    description: 'Moderately competitive - manageable with focused effort',
  },
  LOW: {
    label: 'Low',
    color: 'success',
    icon: <TrendingDown />,
    description: 'Low competition - good opportunity for quick wins',
  },
};

export default function OCIBadge({
  score,
  level,
  size = 'medium',
  showScore = true,
}: OCIBadgeProps) {
  const config = OCI_CONFIG[level];

  // Return null if config is invalid
  if (!config) {
    console.warn('Invalid OCI level:', level);
    return null;
  }

  return (
    <Tooltip title={config.description} arrow>
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
        <Chip
          label={showScore ? `${config.label}: ${score}` : config.label}
          color={config.color}
          size={size}
          icon={config.icon as any}
          sx={{ fontWeight: 600, cursor: 'help' }}
        />
        {showScore && size !== 'small' && (
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ fontSize: '0.75rem' }}
          >
            /100
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
}
